import { WorkSchedulesRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import WorkSchedulesContainer from 'modules/work_schedules/components/WorkSchedulesContainer'

const WorkSchedulesRootPage = () => {
  const { data, loading } = useQuery(WorkSchedulesRootPageDocument, {})
  if (loading) {
    return <Loading />
  }

  return (
    <AuthorizeUser
      authorizeFn={() => data?.workSchedule?._policies?.manageCompanySchedules?.can ?? false}
    >
      <WorkSchedulesContainer />
    </AuthorizeUser>
  )
}

export default WorkSchedulesRootPage
